<template>
	<div :class="['card_box', type]">
		<div class="card_header">
			<div class="title">{{ title }}</div>
		</div>
		<div class="card_content" v-if="info !== null">
			<el-link class="value" @click="handleClick(info)" :underline="false" type="primary"><i class="el-icon-link" style="font-size: 15px; margin-right: 2px"></i> {{ replaceNameShow }}</el-link>
		</div>
	</div>
</template>
 
<script>
export default {
	name: 'ReplaceStandardCard',
	props: {
		info: {
			type: Object,
			default: () => {}
		},
		title: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'danger'
		}
	},
	data() {
		return {};
	},
	methods: {
		handleClick(info) {
			// console.log(info);
			const { replaceId, replaceName, replaceCode } = info;
			if (replaceId) {
				const targetRoute = this.$router.resolve({
					path: '/StandardsDet',
					query: { id: replaceId }
				});
				window.open(targetRoute.href, '_blank');
			}else {
				this.$message.warning('网站没有收录此文件');
			}
		}
	},
	computed: {
		replaceNameShow() {
			const replaceCode = this.info.replaceCode ? this.info.replaceCode + ' ' : '';
			const replaceName = this.info.replaceName ? this.info.replaceName : '';
			return replaceCode + replaceName;
		}
	}
};
</script>
 
<style lang="less" scoped>
.card_box {
	width: 250px;
	background-color: #fff;
	border-radius: 4px;
	// margin-right: 20px;

	// danger类型（红色系）
	&.danger {
		border: 1px solid #ebccd1;

		.card_header {
			background-color: #f2dede;
			border-color: #ebccd1;
			padding: 10px 15px;
			border-bottom: 1px solid transparent;
			border-top-left-radius: 3px;
			border-top-right-radius: 3px;
			.title {
				text-align: center;
				color: #a94442;
			}
		}
	}

	// success类型（绿色系）
	&.success {
		border: 1px solid #d6e9c6;

		.card_header {
			background-color: #dff0d8;
			border-color: #d6e9c6;
			padding: 10px 15px;
			border-bottom: 1px solid transparent;
			border-top-left-radius: 3px;
			border-top-right-radius: 3px;
			.title {
				text-align: center;
				color: #3c763d;
			}
		}
	}

	.card_content {
		padding: 15px;
		text-align: left;
		.label {
			font-size: 14px;
			color: #999;
			margin-bottom: 5px;
		}
		.value {
			font-size: 13px;
		}
	}
}
</style>